import React from 'react';
import { Card, Typography, Row, Col, Space, theme } from 'antd';
import { 
  EnvironmentOutlined,
  PhoneOutlined,
  MailOutlined,
  GlobalOutlined,
  RocketOutlined,
  SafetyOutlined,
  HeartOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;
const { useToken } = theme;

const About: React.FC = () => {
  const { token } = useToken();

  const companyInfo = {
    name: '智子科技',
    englishName: 'Geeker Technology',
    version: 'V2.0',
    founded: '2024年',
    location: '中国·廊坊'
  };

  const contacts = [
    {
      name: '孟经理',
      phone: '18600034103',
      icon: <PhoneOutlined style={{ fontSize: '24px', color: token.colorPrimary }} />
    },
    {
      name: '任经理',
      phone: '15811322824',
      icon: <PhoneOutlined style={{ fontSize: '24px', color: token.colorSuccess }} />
    }
  ];

  const features = [
    {
      icon: <RocketOutlined style={{ fontSize: '32px', color: 'white' }} />,
      title: '技术创新',
      description: '持续创新，引领行业发展'
    },
    {
      icon: <SafetyOutlined style={{ fontSize: '32px', color: 'white' }} />,
      title: '品质保证',
      description: '严格把控，确保产品品质'
    },
    {
      icon: <GlobalOutlined style={{ fontSize: '32px', color: 'white' }} />,
      title: '全球视野',
      description: '立足中国，放眼世界'
    },
    {
      icon: <HeartOutlined style={{ fontSize: '32px', color: 'white' }} />,
      title: '客户至上',
      description: '以客户需求为中心'
    }
  ];

  return (
    <div style={{ padding: '24px', background: token.colorBgContainer, minHeight: '100vh' }}>
      {/* 欢迎标题 - 参考首页风格 */}
      <div style={{ 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '32px 24px',
        borderRadius: '16px',
        marginBottom: '32px',
        border: 'none'
      }}>
        <Title level={2} style={{ 
          color: 'white', 
          margin: 0,
          textAlign: 'center',
          fontSize: '32px',
          fontWeight: 'bold'
        }}>
          {companyInfo.name} - {companyInfo.englishName}
        </Title>
        <Text style={{ 
          color: 'rgba(255,255,255,0.9)', 
          fontSize: '18px',
          textAlign: 'center',
          display: 'block',
          marginTop: '12px',
          fontWeight: '500'
        }}>
          智能物流系统解决方案提供商 - 版本 {companyInfo.version}
        </Text>
      </div>

      {/* 公司信息卡片 - 参考首页数据指标卡片风格 */}
      <Row gutter={[16, 16]} style={{ marginBottom: '32px' }}>
        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            style={{
              background: '#1890ff',
              border: 'none',
              borderRadius: '12px'
            }}
            bodyStyle={{ padding: '24px', textAlign: 'center' }}
          >
            <EnvironmentOutlined style={{ color: 'white', fontSize: '32px', marginBottom: '16px' }} />
            <Title level={4} style={{ color: 'white', margin: '0 0 8px 0', fontSize: '18px' }}>
              总部地址
            </Title>
            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px', fontWeight: '500' }}>
              {companyInfo.location}
            </Text>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            style={{
              background: '#52c41a',
              border: 'none',
              borderRadius: '12px'
            }}
            bodyStyle={{ padding: '24px', textAlign: 'center' }}
          >
            <RocketOutlined style={{ color: 'white', fontSize: '32px', marginBottom: '16px' }} />
            <Title level={4} style={{ color: 'white', margin: '0 0 8px 0', fontSize: '18px' }}>
              成立时间
            </Title>
            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px', fontWeight: '500' }}>
              {companyInfo.founded}
            </Text>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            style={{
              background: '#fa8c16',
              border: 'none',
              borderRadius: '12px'
            }}
            bodyStyle={{ padding: '24px', textAlign: 'center' }}
          >
            <SafetyOutlined style={{ color: 'white', fontSize: '32px', marginBottom: '16px' }} />
            <Title level={4} style={{ color: 'white', margin: '0 0 8px 0', fontSize: '18px' }}>
              系统版本
            </Title>
            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px', fontWeight: '500' }}>
              {companyInfo.version}
            </Text>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card
            hoverable
            style={{
              background: '#722ed1',
              border: 'none',
              borderRadius: '12px'
            }}
            bodyStyle={{ padding: '24px', textAlign: 'center' }}
          >
            <CheckCircleOutlined style={{ color: 'white', fontSize: '32px', marginBottom: '16px' }} />
            <Title level={4} style={{ color: 'white', margin: '0 0 8px 0', fontSize: '18px' }}>
              服务理念
            </Title>
            <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: '16px', fontWeight: '500' }}>
              专业高效
            </Text>
          </Card>
        </Col>
      </Row>

      {/* 主要内容区域 */}
      <Row gutter={[24, 24]} style={{ marginBottom: '32px' }}>
        {/* 左侧：公司简介 */}
        <Col xs={24} lg={12}>
          <Card style={{ 
            height: '100%',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: `1px solid ${token.colorPrimary}20`
          }}
          headStyle={{ 
            background: `${token.colorPrimary}10`,
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
            borderRadius: '12px 12px 0 0'
          }}
          title={
            <Space>
              <RocketOutlined style={{ color: token.colorPrimary }} />
              <span>公司简介</span>
            </Space>
          }>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '16px',
                padding: '20px',
                background: `${token.colorBgContainer}`,
                borderRadius: '8px',
                border: `1px solid ${token.colorBorderSecondary}`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = token.colorPrimary;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = token.colorBorderSecondary;
              }}>
                <EnvironmentOutlined style={{ color: token.colorPrimary, fontSize: '24px' }} />
                <div>
                  <Text strong style={{ 
                    fontSize: '18px', 
                    display: 'block', 
                    marginBottom: '8px',
                    color: token.colorText
                  }}>总部地址</Text>
                  <div style={{ 
                    fontSize: '16px', 
                    color: token.colorPrimary,
                    fontWeight: '500'
                  }}>{companyInfo.location}</div>
                </div>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '16px',
                padding: '20px',
                background: `${token.colorBgContainer}`,
                borderRadius: '8px',
                border: `1px solid ${token.colorBorderSecondary}`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = token.colorSuccess;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = token.colorBorderSecondary;
              }}>
                <RocketOutlined style={{ color: token.colorSuccess, fontSize: '24px' }} />
                <div>
                  <Text strong style={{ 
                    fontSize: '18px', 
                    display: 'block', 
                    marginBottom: '8px',
                    color: token.colorText
                  }}>成立时间</Text>
                  <div style={{ 
                    fontSize: '16px', 
                    color: token.colorSuccess,
                    fontWeight: '500'
                  }}>{companyInfo.founded}</div>
                </div>
              </div>

              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: '16px',
                padding: '20px',
                background: `${token.colorBgContainer}`,
                borderRadius: '8px',
                border: `1px solid ${token.colorBorderSecondary}`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = token.colorWarning;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = token.colorBorderSecondary;
              }}>
                <SafetyOutlined style={{ color: token.colorWarning, fontSize: '24px' }} />
                <div>
                  <Text strong style={{ 
                    fontSize: '18px', 
                    display: 'block', 
                    marginBottom: '8px',
                    color: token.colorText
                  }}>系统版本</Text>
                  <div style={{ 
                    fontSize: '16px', 
                    color: token.colorWarning,
                    fontWeight: '500'
                  }}>{companyInfo.version}</div>
                </div>
              </div>
            </Space>
          </Card>
        </Col>

        {/* 右侧：联系方式 */}
        <Col xs={24} lg={12}>
          <Card style={{ 
            height: '100%',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            border: `1px solid ${token.colorSuccess}20`
          }}
          headStyle={{ 
            background: `${token.colorSuccess}10`,
            borderBottom: `1px solid ${token.colorBorderSecondary}`,
            borderRadius: '12px 12px 0 0'
          }}
          title={
            <Space>
              <PhoneOutlined style={{ color: token.colorSuccess }} />
              <span>联系我们</span>
            </Space>
          }>
            <Space direction="vertical" size="large" style={{ width: '100%' }}>
              {contacts.map((contact, index) => (
                <div key={index} style={{
                  padding: '20px',
                  borderRadius: '8px',
                  background: `${token.colorBgContainer}`,
                  border: `1px solid ${token.colorBorderSecondary}`,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                  e.currentTarget.style.borderColor = token.colorPrimary;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = token.colorBorderSecondary;
                }}>
                  {contact.icon}
                  <div>
                    <Text strong style={{ 
                      fontSize: '18px', 
                      display: 'block', 
                      marginBottom: '8px',
                      color: token.colorText
                    }}>
                      {contact.name}
                    </Text>
                    <a 
                      href={`tel:${contact.phone}`}
                      style={{ 
                        fontSize: '16px', 
                        color: token.colorPrimary,
                        textDecoration: 'none',
                        cursor: 'pointer',
                        fontWeight: '500',
                        display: 'block'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = token.colorPrimaryHover;
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = token.colorPrimary;
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                    >
                      {contact.phone}
                    </a>
                  </div>
                </div>
              ))}

              <div style={{
                padding: '20px',
                borderRadius: '8px',
                background: `${token.colorBgContainer}`,
                border: `1px solid ${token.colorBorderSecondary}`,
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = token.colorWarning;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = token.colorBorderSecondary;
              }}>
                <MailOutlined style={{ fontSize: '24px', color: token.colorWarning }} />
                <div>
                  <Text strong style={{ 
                    fontSize: '18px', 
                    display: 'block', 
                    marginBottom: '8px',
                    color: token.colorText
                  }}>
                    邮箱地址
                  </Text>
                  <a 
                    href="mailto:leo@geeker.net.cn"
                    style={{ 
                      fontSize: '16px', 
                      color: token.colorWarning,
                      textDecoration: 'none',
                      cursor: 'pointer',
                      fontWeight: '500',
                      display: 'block'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = token.colorWarningHover;
                      e.currentTarget.style.textDecoration = 'underline';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = token.colorWarning;
                      e.currentTarget.style.textDecoration = 'none';
                    }}
                  >
                    leo@geeker.net.cn
                  </a>
                </div>
              </div>
            </Space>
          </Card>
        </Col>
      </Row>

      {/* 核心优势 */}
      <Card style={{ 
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: `1px solid ${token.colorInfo}20`
      }}
      headStyle={{ 
        background: `${token.colorInfo}10`,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: '12px 12px 0 0'
      }}
      title={
        <Space>
          <CheckCircleOutlined style={{ color: token.colorInfo }} />
          <span>核心优势</span>
        </Space>
      }>
        <Row gutter={[16, 16]}>
          {features.map((feature, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <div style={{
                padding: '20px',
                borderRadius: '8px',
                background: `${token.colorBgContainer}`,
                border: `1px solid ${token.colorBorderSecondary}`,
                textAlign: 'center',
                transition: 'all 0.3s ease',
                height: '100%'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = token.colorPrimary;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = token.colorBorderSecondary;
              }}>
                <div style={{ marginBottom: '16px' }}>
                  {feature.icon}
                </div>
                <Title level={5} style={{ 
                  color: token.colorText,
                  margin: '0 0 8px 0',
                  fontSize: '16px'
                }}>
                  {feature.title}
                </Title>
                <Text style={{ 
                  color: token.colorTextSecondary,
                  fontSize: '14px',
                  lineHeight: '1.5'
                }}>
                  {feature.description}
                </Text>
              </div>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
};

export default About;
